export * from './attachment.service';
import { AttachmentService } from './attachment.service';
export * from './authenticate.service';
import { AuthenticateService } from './authenticate.service';
export * from './brand.service';
import { BrandService } from './brand.service';
export * from './brandHome.service';
import { BrandHomeService } from './brandHome.service';
export * from './cartProduct.service';
import { CartProductService } from './cartProduct.service';
export * from './category.service';
import { CategoryService } from './category.service';
export * from './document.service';
import { DocumentService } from './document.service';
export * from './hotDeal.service';
import { HotDealService } from './hotDeal.service';
export * from './manufacturer.service';
import { ManufacturerService } from './manufacturer.service';
export * from './notification.service';
import { NotificationService } from './notification.service';
export * from './order.service';
import { OrderService } from './order.service';
export * from './orderHistory.service';
import { OrderHistoryService } from './orderHistory.service';
export * from './priceRequest.service';
import { PriceRequestService } from './priceRequest.service';
export * from './proceedStep.service';
import { ProceedStepService } from './proceedStep.service';
export * from './product.service';
import { ProductService } from './product.service';
export * from './productRepo.service';
import { ProductRepoService } from './productRepo.service';
export * from './productRepoTypeValue.service';
import { ProductRepoTypeValueService } from './productRepoTypeValue.service';
export * from './productType.service';
import { ProductTypeService } from './productType.service';
export * from './productTypeValue.service';
import { ProductTypeValueService } from './productTypeValue.service';
export * from './productViewed.service';
import { ProductViewedService } from './productViewed.service';
export * from './registeredUser.service';
import { RegisteredUserService } from './registeredUser.service';
export * from './repository.service';
import { RepositoryService } from './repository.service';
export * from './role.service';
import { RoleService } from './role.service';
export * from './userAddress.service';
import { UserAddressService } from './userAddress.service';
export * from './users.service';
import { UsersService } from './users.service';
export * from './voucher.service';
import { VoucherService } from './voucher.service';
export * from './warehouse.service';
import { WarehouseService } from './warehouse.service';
export * from './policy.service';
import { PolicyService } from './policy.service';
export * from './systemsettting.service';
import { SystemSettingService } from './systemsettting.service';

export * from './googleAnalytics.service';
import { GoogleAnalyticsService } from './googleAnalytics.service';

export * from './equipmentModel.service';
import { EquipmentModelService } from './equipmentModel.service';
export * from './equipmentType.service';
import { EquipmentTypeService } from './equipmentType.service';
export * from './equipmentCategory.service';
import { EquipmentCategoryService } from './equipmentCategory.service';
export * from './equipmentCompatibleProduct.service';
import { EquipmentCompatibleProductService } from './equipmentCompatibleProduct.service';
export * from './partPackage.service';
import { PartPackageService } from './partPackage.service';
export * from './adminEquipment.service';
import { AdminEquipmentService } from './adminEquipment.service';
export * from './unpaid-order.service';
import { UnpaidOrderService } from './unpaid-order.service';
export * from './productSupplierQuote.service';
import { ProductSupplierQuoteService } from './productSupplierQuote.service';

export const APIS = [
  AttachmentService,
  AuthenticateService,
  BrandService,
  BrandHomeService,
  CartProductService,
  CategoryService,
  DocumentService,
  HotDealService,
  ManufacturerService,
  NotificationService,
  OrderService,
  OrderHistoryService,
  PriceRequestService,
  ProceedStepService,
  ProductService,
  ProductRepoService,
  ProductRepoTypeValueService,
  ProductTypeService,
  ProductTypeValueService,
  ProductViewedService,
  RegisteredUserService,
  RepositoryService,
  RoleService,
  UserAddressService,
  UsersService,
  VoucherService,
  WarehouseService,
  PolicyService,
  SystemSettingService,
  GoogleAnalyticsService,
  EquipmentModelService,
  EquipmentTypeService,
  EquipmentCategoryService,
  EquipmentCompatibleProductService,
  PartPackageService,
  AdminEquipmentService,
  UnpaidOrderService,
  ProductSupplierQuoteService,
];
